import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { title: '后台首页', requiresAuth: true },
    children: [
      {
        path: '/users',
        name: 'Users',
        component: () => import('@/views/Users.vue'),
        meta: { title: '用户管理', requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/students',
        name: 'Students',
        component: () => import('@/views/Students.vue'),
        meta: { title: '学员管理', requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/teachers',
        name: 'Teachers',
        component: () => import('@/views/Teachers.vue'),
        meta: { title: '教师管理', requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/course-major-management',
        name: 'CourseAndMajorManagement',
        component: () => import('@/views/CourseAndMajorManagement.vue'),
        meta: { title: '课程与专业管理', requiresAuth: true }
      },
      {
        path: '/courses',
        name: 'Courses',
        component: () => import('@/views/Courses.vue'),
        meta: { title: '课程管理', requiresAuth: true }
      },
      {
        path: '/enrollments',
        name: 'Enrollments',
        component: () => import('@/views/Enrollments.vue'),
        meta: { title: '报名管理', requiresAuth: true }
      },
      {
        path: '/announcements',
        name: 'Announcements',
        component: () => import('@/views/Announcements.vue'),
        meta: { title: '公告管理', requiresAuth: true, requiresManagerOrAdmin: true }
      },
      {
        path: '/prospectus',
        name: 'Prospectus',
        component: () => import('@/views/Prospectus.vue'),
        meta: { title: '招生简章管理', requiresAuth: true, requiresManagerOrAdmin: true }
      },
      {
        path: '/campus',
        name: 'Campus',
        component: () => import('@/views/Campus.vue'),
        meta: { title: '校区管理', requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/colleges',
        name: 'Colleges',
        component: () => import('@/views/Colleges.vue'),
        meta: { title: '学院管理', requiresAuth: true }
      },
      {
        path: '/majors',
        name: 'Majors',
        component: () => import('@/views/Majors.vue'),
        meta: { title: '专业管理', requiresAuth: true }
      },
      {
        path: '/finance',
        name: 'Finance',
        component: () => import('@/views/Finance.vue'),
        meta: { title: '财务管理', requiresAuth: true }
      },
      {
        path: '/statistics',
        name: 'Statistics',
        component: () => import('@/views/Statistics.vue'),
        meta: { title: '统计数据管理', requiresAuth: true }
      },
      {
        path: '/system-config',
        name: 'SystemConfig',
        component: () => import('@/views/SystemConfig.vue'),
        meta: { title: '系统配置', requiresAuth: true, requiresAdmin: true }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || '老年大学管理系统'
  
  // 判断是否需要登录
  if (to.meta.requiresAuth) {
    const isLoggedIn = store.getters.isLoggedIn
    
    if (isLoggedIn) {
      const userInfo = store.getters.userInfo
      
      // 判断是否需要管理员权限
      if (to.meta.requiresAdmin) {
        if (userInfo && userInfo.userType === 'ADMIN') {
          next()
        } else {
          // 非管理员访问管理员页面，跳转到首页
          next('/dashboard')
        }
      } 
      // 判断是否需要教务或管理员权限
      else if (to.meta.requiresManagerOrAdmin) {
        if (userInfo && (userInfo.userType === 'ADMIN' || userInfo.userType === 'MANAGER')) {
          next()
        } else {
          // 非教务/管理员访问，跳转到首页
          next('/dashboard')
        }
      } 
      else {
        next()
      }
    } else {
      next('/login')
    }
  } else {
    // 如果已经登录且访问登录页，则跳转到首页
    if (to.path === '/login' && store.getters.isLoggedIn) {
      next('/dashboard')
    } else {
      next()
    }
  }
})

export default router

